import { getClipboardFiles } from "../../../shared/clipboardFiles";

export const AI_CHAT_MAX_FILES = 8;

export const isImageFile = (value) =>
  Boolean(
    value?.type?.startsWith("image/") ||
      /\.(png|jpe?g|webp|gif|bmp|tiff?)$/i.test(value?.name || ""),
  );

export const isAiChatFile = (value) =>
  Boolean(
    isImageFile(value) ||
      value?.type === "application/pdf" ||
      /\.pdf$/i.test(value?.name || ""),
  );

export const getAiChatFiles = (fileList) =>
  Array.from(fileList || []).filter(isAiChatFile);

export const getAiChatFileId = (file) =>
  [file?.name || "", file?.size || 0, file?.lastModified || 0, file?.type || ""].join(":");

export const getAiChatFileKindLabel = (file) =>
  file?.type === "application/pdf" || /\.pdf$/i.test(file?.name || "") ? "PDF" : "圖片";

export const mergeAiChatFiles = (
  currentFiles,
  nextFiles,
  maxFiles = AI_CHAT_MAX_FILES,
) => {
  const seen = new Set((currentFiles || []).map(getAiChatFileId));
  const merged = [...(currentFiles || [])];

  (nextFiles || []).forEach((file) => {
    const fileId = getAiChatFileId(file);
    if (seen.has(fileId) || merged.length >= maxFiles) return;
    seen.add(fileId);
    merged.push(file);
  });

  return merged;
};

export const getPastedAiChatFiles = (clipboardData) =>
  getAiChatFiles(getClipboardFiles(clipboardData));

export const buildAiChatFileSummaries = (files) =>
  (files || []).map((file) => ({
    name: file.name,
    size: file.size,
    kind: getAiChatFileKindLabel(file),
  }));
